import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import AddCircle from '@material-ui/icons/AddCircle';
import { createElement, FC, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { SPACING_UNIT } from '../../../constant/spacing';
import { FormatSelector } from './FormatSelector';

type Props = {
  onClick: () => void;
  className?: string;
};

const AddOriginalFormatsButton: FC<Props> = ({ onClick, className }) => {
  return (
    <>
      <FormatSelector onClick={onClick} className={className}>
        <StandbyIcon color="primary" />
        <StandbyDescription variant="body2">
          <FormattedMessage id="project_editing_page.basic_setting.creative_formats.add_formats" />
        </StandbyDescription>
      </FormatSelector>
    </>
  );
};

const StandbyIcon = styled(AddCircle)({
  gridArea: 'icon',
  width: 48,
  height: 48,
});

const StandbyDescription = styled(Typography)({
  gridArea: 'description',
  marginTop: SPACING_UNIT,
});

export default AddOriginalFormatsButton;
